import { Component, OnInit } from '@angular/core';
import { Subject } from "rxjs";
import { Router } from "@angular/router";
import { AdsService } from '../Services/ads.service';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { CookieService } from '../Services/cookie';
import { DatePipe } from '@angular/common';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: "app-landing-page-offer-details",
  templateUrl: "./landing-page-offer-details.component.html",
  standalone:false,
  styleUrls: ["./landing-page-offer-details.component.scss"],
})
export class LandingPageOfferDetailsComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  offerid: string;
  offerpage: any;
  flashdeal: boolean;
  Pagination: Number = 1;
  Category: string = "";
  Cardcode: string = "";
  offerSlider: any;
  landingPage: string;
  
  carouselOptions: OwlOptions = {
  loop: false,
  nav: false,
  dots: true,
  items: 1,
  autoWidth: false,
  autoHeight: false,
  responsive: {
    0: { items: 1 },
    600: { items: 1 },
    1000: { items: 1 }
  }
};

  constructor(private router: Router, public datepipe: DatePipe,
    private cookieService: CookieService, private Ads: AdsService, private common: CommonService, public auth: AuthService) { }
  FavouriteOffers: any;
  activeTab: number;
  disabled;

  async ngOnInit(): Promise<any> {

    this.common.presentLoading();
     this.landingPage = localStorage.getItem("Landingpage");
    console.log("pageNo",this.landingPage);
    
    let item =await this.cookieService.get("offerdetail", true);
    console.log("item", item)
    // const obj = JSON.parse(JSON.stringify({ item: this.cookieService.get("offerdetail",false) }));

    if (item) {

      this.FavouriteOffers = await JSON.parse(item)

    }

    let a =await this.cookieService.get("offerid", true);

    if (a) {

      this.offerid = a;


    }

    let P = this.cookieService.get("offerpage", true);

    if (P) {

      this.offerpage = P;


    }


    let pg =await this.cookieService.get("Pageination", true);

    if (pg != "undefined" && pg != "") {

      this.Pagination = JSON.parse(pg);

    }
    else {
      this.Pagination = 1;
    }

    let Cat =await this.cookieService.get("Category", true);

    // if (Cat != "undefined") {

    this.Category = Cat;

    // }
    // else{
    //   this.Category = ""
    // }

    this.auth.accessToken = await this.common.Get("token");
    if (this.offerpage == "OffersLanding") {


      this.flashdeal = false;
    }
    else {
      this.flashdeal = true;

    }

    let C = this.cookieService.get("Cardcode", false);

    // if (C == undefined || C == "undefined" ) {

    this.Cardcode = "";


    //}
    // else{

    //   this.Cardcode = C
    // }

    await  this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {  

          if (data?.response?.code == 1) {

           
            // this.cookieService.set("detailuser",JSON.stringify(data.response.content.allowedServices),false,undefined,undefined,undefined,undefined,true,"Strict")
            await this.Ads.GetFavouriteOffers(this.auth.accessToken).then((data: any) => {
              if (data?.response.code == 1) {
                this.FavouriteOffers = data.response.content;

                console.log('GetFavouriteOffers', this.FavouriteOffers)
              }
              else {
                this.common.hideLoading();
                this.common.ParseErrorAlert('', 'OK', this.router, data)
              }
            })
        
          } else {

            // await this.common.hideLoading();
            // this.common.ParseErrorAlert("", "", this.router, data);
          }
       
      
    });
    // if (this.auth.detailuser != null) {
    //   await this.Ads.GetFavouriteOffers(this.auth.accessToken).then((data: any) => {
    //     if (data?.response.code == 1) {
    //       this.FavouriteOffers = data.response.content;

    //       console.log('GetFavouriteOffers', this.FavouriteOffers)
    //     }
    //     else {
    //       this.common.hideLoading();
    //       this.common.ParseErrorAlert('', 'OK', this.router, data)
    //     }
    //   })
    // }

    await this.Ads.GetOffersPaginated(this.Category.toString(), this.Cardcode.toString(), this.flashdeal, this.Pagination).then((data: any) => {

      if (data?.response.code == 1) {
        console.log("margaya",data);
        
        this.offerSlider = data.response.content.data;

        
        if (this.FavouriteOffers != null && this.FavouriteOffers != undefined) {

          this.offerSlider.forEach(element => {


            let Fav =  this.FavouriteOffers.filter(x=> x.offerid == element.id);
              if (Fav.length > 0) {

                element['heart'] = true;

              }
              else{

                element['heart'] = false;


              }


          });
          console.log('this.offerSlider', this.offerSlider)
        }


        if (this.offerid == undefined || this.offerid == "undefined") {

          this.common.hideLoading();
          this.cookieService.delete("Pageination");
          this.cookieService.delete("offerpage");
          this.router.navigateByUrl("/LandingPageMyFavourites");

        }
        else {
          let F = data.response.content.data.filter(x => x.id == this.offerid);

          this.FavouriteOffers = F[0];
          console.log('GetFavouriteOffers', this.FavouriteOffers)

          this.common.hideLoading();
          this.cookieService.delete("Pageination");



        }

      }
      else {
        this.common.hideLoading();
        this.cookieService.delete("offerid");
        this.cookieService.delete("offerpage");
        this.common.ParseErrorAlert('', 'OK', this.router, data)
      }
    })






  } 
  showModal(num) {
    this.modalObservable.next(num);
  }
  loginWithIdNum() {
    this.router.navigateByUrl("/LoginWithIdNum");
  }
  LandingPageMyFavourites() {
    this.router.navigateByUrl("/LandingPageMyFavourites");
  }
  changeTab(e) {
    this.activeTab = e;
  }

  slideConfig = {
    slidesToShow: 3,
    slidesToScroll: 3,
    vertical: false,
    arrows: false,
    dots: true,
    adaptiveHeight: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
        },
      },
    ],
  };

  // back(){
  //   this.router.navigateByUrl("/LandingPageOffers");
  // }

  back() {
    if (this.landingPage === "landingpage") {
      this.router.navigateByUrl("/LandingPage");
    } else {
      this.router.navigateByUrl("/LandingPageOffers");
    }
  }
  

  async logOut() { }
}
